import React, { Fragment, useEffect, useMemo, useState } from "react";
import { URLS } from "../urls";
import moment from "moment";
import { Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
// import Select from "react-select";
// import CurrencyInput from "react-currency-input-field";
import { branch_id, allMonths, fetchActionsUtil } from "../../utils";

const SentToAccount = ({
  Amount,
  payrollDate,
  employeeType,
  deductionItems,
  show,
  onShow,
  category,
  salaryType,
}) => {
  const [state, setState] = useState({
    buttonText: "Submit",
    isWaiting: false,
    Amount: Amount,
    applyDate: moment(new Date()).format("DD/MM/YYYY"),
    staff: "",
    departments: [],
    users: [],
    comment: "",
    appliedDate: "",
    description: "",
    payrollMonth: payrollDate.payrollMonth,
    payrollYear: payrollDate.payrollYear,
    employeeType: employeeType,
    deductionItems: deductionItems,
    category: category,
    salaryType: salaryType,
  });

  useEffect(() => {
    let IsFetching = true;
    if (IsFetching) {
      getDepartments();
    }
    return () => {
      IsFetching = false;
    };
  }, []);

  const getDepartments = async () => {
    // await waitFor(5000);
    if (process.env.REACT_APP_HAS_INVEX === "true") {
      let response = await fetch(`${URLS.mainSiteBackend}/users/departments`, {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        // credentials: "include",
      });

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }
      const { data } = await response.json();

      setState((el) => ({
        ...el,
        departments: data?.departments,
      }));
    }
  };

  const getUsersInDepartments = async (department) => {
    let response = await fetch(
      `${URLS.mainSiteBackend}/users/by-department/${department}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        // credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    setState((el) => ({
      ...el,
      users: data?.users,
    }));
  };

  const onChangeInputs = (e) => {
    const { name, value } = e.target;
    setState((el) => ({
      ...el,
      [name]: value,
    }));
  };

  const title = useMemo(() => {
    const fullAndFinally = Boolean(salaryType);
    const titleName = `${allMonths[state.payrollMonth - 1]} ${
      state.payrollYear
    }`;
    const description = `${titleName} ${
      fullAndFinally ? "Full And Final" : "Salary"
    }`;
    setState((prev) => ({
      ...prev,
      description,
    }));
    return description;
  }, [salaryType, state.payrollMonth, state.payrollYear]);

  const submit = async (e) => {
    e.preventDefault();

    // Set loading state
    setState((prev) => ({
      ...prev,
      buttonText: "Submitting...",
      isWaiting: true,
    }));

    try {
      const {
        comment,
        Amount,
        staff,
        payrollMonth,
        payrollYear,
        employeeType,
        deductionItems,
        category,
        salaryType,
      } = state;

      const fullAndFinally = Boolean(salaryType);
      const token = "dummy token";

      // Prepare request data
      const requisitionData = {
        title,
        description: title,
        type: "Salary",
        amount: Amount,
        requestto: staff,
        status: "Pending",
        regdate: moment(new Date()).format("YYYY-MM-DD"),
        requestby: staff,
        vendor: "",
        comment,
        filledFormData: "",
        loanDetails: JSON.stringify({
          payrollMonth,
          payrollYear,
          Amount,
          deductionItems,
        }),
      };

      const sendBody = {
        Amount,
        status: "Pending",
        paymentsStatus: "Not paid",
        requestid: "",
        branch_id,
        payrollMonth,
        payrollYear,
        employeeType,
        category,
        fullAndFinally,
      };

      // First API call - Create requisition
      const formData = new FormData();
      Object.entries(requisitionData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      if (process.env.REACT_APP_HAS_INVEX !== "true") {
        throw new Error("Environment not configured for requisition");
      }

      const requisitionResponse = await fetch(
        `${URLS.mainSiteBackend}/requisition/create`,
        {
          method: "POST",
          headers: { Authorization: `Token ${token}` },
          body: formData,
        }
      );

      if (!requisitionResponse.ok) {
        const errorData = await requisitionResponse.json();
        throw new Error(errorData.message || "Requisition creation failed");
      }

      const requisitionResult = await requisitionResponse.json();
      const requestId = requisitionResult?.data?.requisition?.requestid;

      // Second API call - Create salary record
      await fetchActionsUtil(URLS.backendSalary, "POST", token, {
        ...sendBody,
        requestid: requestId,
      });

      // Success case
      toast.success("Request Sent Successfully.", {
        position: "top-right",
      });

      // Reset form state
      setState((prev) => ({
        ...prev,
        buttonText: "Submit",
        isWaiting: false,
        staff: "",
        departments: [],
        users: [],
        comment: "",
        appliedDate: "",
        title: "",
        description: "",
        Amount: 0,
        employeeType: "",
        payrollMonth: "",
        payrollYear: "",
        category: "",
        salaryType: "",
      }));

      onShow();
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Error occurred, Check the form again.", {
        position: "top-right",
      });
    } finally {
      // Reset loading state
      setState((prev) => ({
        ...prev,
        buttonText: "Submit",
        isWaiting: false,
      }));
    }
  };

  const {
    departments,
    users,
    staff,
    buttonText,
    description,
    comment,
    isWaiting,
  } = state;

  return (
    <Modal show={show} size="md" onHide={onShow}>
      <div>
        <div>
          <Modal.Header closeButton>
            <Modal.Title>Request for approval</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={submit}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Description <span className="text-danger">*</span> :
                </Form.Label>
                <label className="border p-0 rounded pb-2 message-area d-block">
                  <Form.Control
                    name="description"
                    value={description}
                    onChange={onChangeInputs}
                    as="textarea"
                    className="w-100 border-0 p-3"
                    placeholder="Enter your detail description"
                    rows={4}
                    required
                  />
                </label>
              </Form.Group>

              <div className="d-flex align-items-center my-4">
                <h4 className="pr-2">Send Request To</h4>
                <hr className="flex-grow-1 m-0" />
              </div>

              <div className="row gap-3">
                <Form.Group className="col mb-3">
                  <Form.Label>
                    Department <span className="text-danger">*</span> :
                  </Form.Label>
                  <select
                    className="form-control"
                    onChange={(e) => getUsersInDepartments(e.target.value)}
                    required
                  >
                    <option value="">Select Recipient's Department</option>
                    {departments &&
                      departments.map((el, index) => (
                        <option key={index} value={el.Department}>
                          {el.Department}
                        </option>
                      ))}
                  </select>
                </Form.Group>

                {users.length > 0 && (
                  <Form.Group className="col mb-3">
                    <Form.Label>
                      Recipient <span className="text-danger">*</span> :
                    </Form.Label>
                    <select
                      name="staff"
                      className="form-control"
                      value={staff}
                      onChange={onChangeInputs}
                      required
                    >
                      <option value="">Select Recipient </option>
                      {users.map((el, index) => (
                        <Fragment key={index}>
                          <option value={el.Staff_ID}>{el.Name}</option>
                        </Fragment>
                      ))}
                    </select>
                  </Form.Group>
                )}
              </div>

              <Form.Group className="mb-3">
                <Form.Label>Comment :</Form.Label>
                <label className="border p-0 rounded pb-2 message-area d-block">
                  <Form.Control
                    name="comment"
                    value={comment}
                    onChange={onChangeInputs}
                    as="textarea"
                    className="w-100 border-0 p-3"
                    placeholder="Enter a comment"
                    rows={4}
                  />
                </label>
              </Form.Group>
              <div className="submit-section">
                <button
                  className="btn btn-primary submit-btn"
                  disabled={isWaiting}
                >
                  {buttonText}
                </button>
              </div>
            </form>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};

export default SentToAccount;
